import tinycolor from 'tinycolor2';
import { WCAG_AA_RATIO } from './wcag';

const LIGHT_SURFACE = 'hsl(0, 0%, 100%)';
const MAX_DARKEN_STEPS = 100;

const darkenUntilReadable = (color: tinycolor.Instance, stepsLeft: number): tinycolor.Instance =>
  stepsLeft <= 0 || tinycolor.readability(color, LIGHT_SURFACE) >= WCAG_AA_RATIO
    ? color
    : darkenUntilReadable(color.clone().darken(1), stepsLeft - 1);

export const getReadableTextColor = (color: string): string => {
  const initial = tinycolor(color);
  if (!initial.isValid()) {
    return color;
  }

  return darkenUntilReadable(initial, MAX_DARKEN_STEPS).toHslString();
};
